export default __webpack_public_path__ + "static/nutritional-health-product-card-199ef2205b0a403a3f7b4743d221fe0f.jpg";